import React from "react";

export const ShareLogo = ({ size = 32, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 64 64" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shield outer shape */}
      <path
        d="M32 4L8 14V30C8 46 32 60 32 60C32 60 56 46 56 30V14L32 4Z"
        fill="url(#shieldGradient)"
        stroke="#FF3366"
        strokeWidth="2"
      />
      
      {/* Heart inside */}
      <path
        d="M32 48C32 48 18 38 18 28C18 23.5 21.5 20 26 20C28.5 20 30.8 21.2 32 23C33.2 21.2 35.5 20 38 20C42.5 20 46 23.5 46 28C46 38 32 48 32 48Z"
        fill="white"
      />
      
      {/* Gradient definition */}
      <defs>
        <linearGradient id="shieldGradient" x1="8" y1="4" x2="56" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF3366" />
          <stop offset="1" stopColor="#FF6B8A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ShareLogoFull = ({ size = 40, className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <ShareLogo size={size} />
      <span 
        className="text-xl font-extrabold tracking-tight text-slate-900"
        style={{ fontFamily: 'Outfit, sans-serif' }}
      >
        RATE<span className="text-amber-400">⭐</span>SHARE
      </span>
    </div>
  );
};

export default ShareLogo;
